export default __webpack_public_path__ + "static/media/11_maio.2cc431c4.gif";